import React, { useContext, useState, useSyncExternalStore } from 'react';
import '../Default.css';
import './User.css';
import { AuthProvider } from '../globalContext';
import { userStateStore } from '../zhr/users/usersStateStore';
import { ListProps, SendingStatus, UserProfileInfoType } from './userProfileInfoType';
import UserActionPanel from './UserActionPanel';


const TEXTAREA_MAX_LENGTH: number = 200;


function User({ children }: ListProps) {

  const [isEditMode, setEditMode] = useState(false as boolean);
  const [editedEntry, setEditedEntry] = useState({} as UserProfileInfoType); 
  const [sendingStatus, setSendingStatus] = useState({isSending:false, msg:"", isSaved:false} as SendingStatus)

  const { id: userId } = useContext(AuthProvider);

  const user = useSyncExternalStore(
    userStateStore.subscribe.bind(null, userId),
    userStateStore.getUser.bind(null, userId)
  );


  const startEdit = (entryIndex: number): void => {
    setSendingStatus({isSending: false, msg: "", isSaved: false});
    setEditedEntry(userInfo[entryIndex]);
    setEditMode(true);
  }

  const cancelEdit = (): void => {
    setEditMode(false);
  }

  const approveEdit = (): void => {
    if (user && editedEntry.name === "opis")
    {
      const description: string = editedEntry.value.toString();

      setSendingStatus({ isSending: true, msg: "Zapisywanie...", isSaved: false });

      sendDescriptionToServer("/api/user/description", description)
        .then(response => {
          if (response.status === 200) {
            user.description = description
            userStateStore.updateCallback(userId, user);
            setSendingStatus({ isSending: false, msg: "Zapisywanie...", isSaved: true });
          }
          else {
            setSendingStatus({ isSending: false, msg: "Zapisanie zmian nie powiodło się!", isSaved: false });
          }
        })
        .catch(error => {
          setSendingStatus({ isSending: false, msg: "Zapisanie zmian nie powiodło się!", isSaved: false });
          console.log(error);
        });
    }
    else 
    {
      setSendingStatus({ isSending: false, msg: "Niedozwolona zmiana!", isSaved: false });
    }    

    setTimeout(() => setEditMode(false), 2000); 
  }
  
  const sendDescriptionToServer = async (endpoint: string, description: string) => {
    return await fetch(endpoint, {
      method: "POST",
      headers: { 'Content-Type': 'application/json' },
      credentials: "same-origin",
      body: JSON.stringify({description})
    });
  }

  // IF IS SOMETHING WRONG WITH USER OBJECT
  if (!user || user === null)
  {
    return (
      <>
        <div className="page-title">
          Profil
        </div>
        <div className='boxes-contener'>
          <div className='text-box'>
            <div className='text-box-header'>Dane</div>
            <div className='paragraf'>Nie udało się pobrać danych!</div>
          </div>
        </div>
        <UserActionPanel>
          {children}
        </UserActionPanel> 
        <div className='boxes-contener'></div>
      </>
    )
  }


  const userInfo: UserProfileInfoType[] = [
    { name: "imię", value: user.name, isEditEnable: false },
    { name: "nazwisko", value: user.surname, isEditEnable: false },
    { name: "kod ZHR", value: user.zhr_code, isEditEnable: false },
    { name: "opis", value: user.description, isEditEnable: true }
  ];


  // IF USER IS EDITING PROFILE
  if (isEditMode)
  {
    if (!editedEntry || editedEntry.name !== "opis") cancelEdit();
    return (
      <>
        <div className="page-title">
          Profil
        </div>
        <div className='boxes-contener'>
          <div className='text-box'>
            <div className='text-box-header'>Edytuj { editedEntry.name }</div>

            <textarea
              disabled={sendingStatus.isSending}
              className='user-data-edit-box'
              name="edit-box" 
              id="edit-box" 
              value={editedEntry.value}
              onChange={e => setEditedEntry({...editedEntry, value:e.target.value})}
              rows={10}
              maxLength={TEXTAREA_MAX_LENGTH}
            ></textarea>
            <div>{editedEntry.value.toString().length} / {TEXTAREA_MAX_LENGTH}</div>

            <div className='user-data-edit-buttons'>
              <button
                disabled={sendingStatus.isSending}
                className='cancel' 
                type="button" 
                onClick={() => cancelEdit()}
              >anuluj</button>
              <button
                disabled={sendingStatus.isSending}
                className='approve'
                type="button"
                onClick={() => approveEdit()}
              >zatwierdź</button>
            </div>
              <span 
                className={
                  sendingStatus.isSending
                    ? 'status-pending'
                    : sendingStatus.isSaved
                      ? 'status-ok'
                      : 'status-not-ok'
                }
              >{ sendingStatus.msg }</span>
          </div>
        </div>
        <div className='boxes-contener'></div>
      </>
    )
  }

  // DEFAULT 
  return (
    <>
      <div className="page-title">
        Profil
      </div>
      <div className='boxes-contener'>
        <div className='text-box'>
          <div className='text-box-header'>Dane</div>
          <div className='user-data-table'>
            {userInfo.map((entry, index) => 
              <div key={index} className='user-data-table-row'>
                <div className='user-data-table-row-key'>
                  <p>{entry.name}</p>
                  {entry.isEditEnable &&
                    <img 
                      className='img'
                      src="/icons/pen-to-square-solid.svg"
                      alt="edytuj"
                      onClick={() => startEdit(index)}
                    ></img>                 
                  }
                </div>
                <p className='user-data-table-row-value'>{entry.value}</p>
              </div>
            )}    
          </div>
        </div>
      </div>
      <UserActionPanel>
        {children}
      </UserActionPanel>      
      <div className='boxes-contener'></div>
    </>
  );
}

export default User;
